import React from "react";

const ICVImageViewComponent = ({text,imagePath}:any) => {
  return (
    <>
    <div className="p-2">
      <img
        src={"data:image/jpeg;base64," + imagePath}
        style={{ width: "100%", height: "265px",borderRadius:'25px'}}
        alt=""
      />
    </div>
    <div style={{marginBottom:'20px', padding: '2%'}} >
    <text style={{color:'black',fontWeight:'bold',fontSize:'24px',width:125}}>{text}</text>
    </div>
    </>
  );
};
export default ICVImageViewComponent;
